import Axios from 'axios'
import { parseAuthenticationHeader } from 'helpers/Functions'
import { getWithRedirect, postWithRedirect } from 'utils/axios'

export interface MFAStatusResponse {
  mfa_enabled: boolean
  preferred_mfa: string | null
}

export interface MFASetupResponse {
  secret_code: string
  qr_code: string
}

export interface MFAVerifyResponse {
  status: string
  mfa_enabled: boolean
}

const BASE_URL =
  process.env.NODE_ENV === 'development'
    ? 'http://localhost:3990/'
    : process.env.REACT_APP_HOMEPAL_MDM_API_PROD

const URL = `${BASE_URL}v1/users/mfa`

/**
 * Get MFA status for current user
 */
export const getMFAStatus = async () => {
  return getWithRedirect<MFAStatusResponse>(`${URL}/status`)
}

/**
 * Setup MFA - Get QR code and secret
 */
export const setupMFA = async () => {
  return postWithRedirect<MFASetupResponse>(`${URL}/setup`, {})
}

/**
 * Verify TOTP code and enable MFA
 */
export const verifyMFA = async (code: string) => {
  return postWithRedirect<MFAVerifyResponse>(`${URL}/verify`, {
    data: {
      code
    }
  })
}

/**
 * Disable MFA for current user. Needs a current code from the user's app.
 */
export const disableMFA = async (code: string): Promise<void> => {
  return Axios.delete(URL, {
    ...parseAuthenticationHeader(),
    data: { data: { code } }
  })
}
